import React, { Component, useState } from "react";
import axios from "axios";
import LogoDark from "../../assets/LogoDark";
import { connect } from "react-redux";
import * as actions from "../../state/actions/onboarding";

const performPasswordRecovery = ({ email }, setLoading, setMessage, setErrorMessage) => {
  setLoading(true);
  setErrorMessage(null);
  axios
    .post(`${process.env.REACT_APP_BACKEND_URL}/passwordrecovery`, {
      email
    })
    .then(response => {
      setMessage("Thanks! Check your email for further instructions!");
    })
    .catch(error => {
      setErrorMessage("Invalid Email");
      console.log("Failed to Initiate PasswordRecovery: ", error);
    })
    .finally(() => {
      setLoading(false);
    });
};

function PasswordRecovery() {
  const [email, setEmail] = useState(null);
  const [loading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [message, setMessage] = useState(null);

  const handleSubmit = () => {
    performPasswordRecovery({ email }, setLoading, setMessage, setErrorMessage);
  };

  return (
    <div className="bg-gray-100 h-screen w-screen p-20 outerContainer">
      <div className="flex flex-col flex-shrink-0 p-6 max-w-sm my-20 mx-auto bg-white rounded border border-gray-300 innerContainer">
        <LogoDark
          className="text-4xl mx-auto"
          black
          style={{ justifyContent: "center" }}
        />
        <div className="w-full my-3 p-2 text-center">
          What's the email linked to your account?
        </div>
        <input
          type="text"
          name="email"
          value={email}
          placeholder="Enter email address"
          className="w-full my-3 p-2 border border-gray-300 rounded-sm bg-white"
          onChange={e => {
            setEmail(e.target.value);
          }}
        />
        <div className={errorMessage ? "text-red-600 p-2" : "hidden"}>
          {errorMessage}
        </div>
        <div className={message ? "p-2" : "hidden"}>{message}</div>
        <input
          type="button"
          name="button"
          onClick={() => handleSubmit()}
          value="Confirm"
          className={`w-full p-4 bg-green-primary text-white rounded-sm loginButton
            ${loading ? "disabled opacity-50 cursor-not-allowed" : ""}`}
        />
      </div>
    </div>
  );
}

export default connect(
  state => ({}),
  actions
)(PasswordRecovery);
